var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loader-component",class:{ fixed: _vm.fixed, absolute: _vm.absolute, 'color-red': _vm.colorRed, transparent: _vm.transparent }},[_c('div')])}
var staticRenderFns = []

export { render, staticRenderFns }